import React from "react"
import "./index.scss"

const SelectPanel = ({ title, options, selectedOption, setOptionFilter }) => {

    const handleOptionClick = (status) => {
        setOptionFilter(status)
    }

    return (
        <div className="filter-panel">
            <span className="filter-panel-span t-s4">{title}:</span>
            {options.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    onClick={() => handleOptionClick(option.id)}
                    className={`filter-panel-button ${selectedOption === option.id ? "filter-panel-button-selected t-s3" : "t-s4"}`}
                >
                    {option.name}
                </button>
            ))}
        </div>
    )
}

export default SelectPanel
